
function updateDiscountInformation(cart) {
    let hasDiscount = false;
    const items = cart.cart.items;
    
    // Check if any item has a discount
    const discountElement = document.querySelector('[data-rebuy-cart-anchor="footer"] .buy-more-discount-display');
    if (discountElement) {
        discountElement.classList.toggle('hidden', cart.cart.total_discount == 0);
    }

    const totalDiscount = document.querySelector('[data-rebuy-cart-anchor="footer"] .total-discount');
    if (totalDiscount) {
        let discountAmount = cart.cart.total_discount;
        let formattedDiscount = Rebuy.SmartCart.formatMoney(discountAmount);
        totalDiscount.innerHTML = `-${formattedDiscount}`;
    }
}

function updateItemCount(cart) {
    const itemCount = cart.cart.item_count;
    const itemCountElement = document.querySelector('#rebuy-cart-title');
    if (itemCountElement) {
        itemCountElement.textContent = `Your Cart (${itemCount})`;
    }
}

document.addEventListener("rebuy:cart.ready", function(event) {
    const {cart} = event.detail;
    updateDiscountInformation(cart);
    updateItemCount(cart);
});

document.addEventListener("rebuy:cart.change", function(event) {
    const {cart} = event.detail;
    updateDiscountInformation(cart);
    updateItemCount(cart);
});
